<!-- ----------------------------------------------- -->
<template>
  <v-layout column class="card">
    <tm-over-list></tm-over-list>
  </v-layout>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 テレメータ超過一覧
 * TmOvList.vue
 * @author LIS
 */

/** テレメータ超過一覧カード */
import TmOverList from "../../components/pc/full/TmOverList.vue";

export default {
  data() {
    return {
      tabIndex: 0
    };
  },
  components: {
    TmOverList
  },
  methods: {
    setTabIndex(index) {
      this.tabIndex = index;
    }
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.card {
  padding: 16px;
  height: 100%;

  & * + * {
    margin-top: 16px;
  }
}
</style>
